import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { getFeeHistory, getLatestBlock } from './provider';
import { gwei, hexlify, max, roundToWholeGwei } from './utils';
var MAX_GAS_FAST = gwei(1500n);
var FEE_HISTORY_BLOCKS = 10;
var FEE_HISTORY_PERCENTILE = 5;
var PRIORITY_FEE_ESTIMATION_TRIGGER = gwei(100n);
var DEFAULT_PRIORITY_FEE = gwei(3n);
export var FALLBACK_ESTIMATE = {
  maxFeePerGas: gwei(20n),
  maxPriorityFeePerGas: DEFAULT_PRIORITY_FEE,
  baseFee: undefined
};
var PRIORITY_FEE_INCREASE_BOUNDARY = 200;

var getBaseFeeMultiplier = function getBaseFeeMultiplier(baseFee) {
  if (baseFee <= gwei(40n)) {
    return 200n;
  } else if (baseFee <= gwei(100n)) {
    return 160n;
  } else if (baseFee <= gwei(200n)) {
    return 140n;
  } else {
    return 120n;
  }
};

var calculatePriorityFeeEstimate = function calculatePriorityFeeEstimate(feeHistory) {
  var _feeHistory$reward;

  if (!feeHistory) {
    return null;
  }

  var rewards = (_feeHistory$reward = feeHistory.reward) === null || _feeHistory$reward === void 0 ? void 0 : _feeHistory$reward.map(function (r) {
    return BigInt(r[0]);
  }).filter(function (r) {
    return r > 0n;
  }).sort();

  if (!rewards) {
    return null;
  }

  var percentageIncreases = rewards.reduce(function (acc, cur, i, arr) {
    if (i === arr.length - 1) {
      return acc;
    }

    var next = arr[i + 1];
    var p = (next - cur) / cur * 100n;
    return [].concat(_toConsumableArray(acc), [p]);
  }, []);
  var highestIncrease = max(percentageIncreases);
  var highestIncreaseIndex = percentageIncreases.findIndex(function (p) {
    return p === highestIncrease;
  });
  var values = highestIncrease >= PRIORITY_FEE_INCREASE_BOUNDARY && highestIncreaseIndex >= Math.floor(rewards.length / 2) ? rewards.slice(highestIncreaseIndex) : rewards;
  return values[Math.floor(values.length / 2)];
};

export var calculateFees = function calculateFees(baseFee, feeHistory) {
  try {
    var estimatedPriorityFee = calculatePriorityFeeEstimate(feeHistory);
    var maxPriorityFeePerGas = max([estimatedPriorityFee !== null && estimatedPriorityFee !== void 0 ? estimatedPriorityFee : 0n, DEFAULT_PRIORITY_FEE]);
    var multiplier = getBaseFeeMultiplier(baseFee);
    var potentialMaxFee = baseFee * multiplier / 100n;
    var maxFeePerGas = maxPriorityFeePerGas > potentialMaxFee ? potentialMaxFee + maxPriorityFeePerGas : potentialMaxFee;

    if (maxFeePerGas >= MAX_GAS_FAST || maxPriorityFeePerGas >= MAX_GAS_FAST) {
      throw new Error('Estimated gas fee was much higher than expected, erroring');
    }

    return {
      maxFeePerGas: roundToWholeGwei(maxFeePerGas),
      maxPriorityFeePerGas: roundToWholeGwei(maxPriorityFeePerGas),
      baseFee: baseFee
    };
  } catch (err) {
    console.error(err);
    return FALLBACK_ESTIMATE;
  }
};
export var estimateFees = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
    var latestBlock, baseFee, blockNumber, feeHistory;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getLatestBlock(provider);

          case 3:
            latestBlock = _context.sent;

            if (latestBlock.baseFeePerGas) {
              _context.next = 6;
              break;
            }

            throw new Error('An error occurred while fetching current base fee, falling back');

          case 6:
            baseFee = BigInt(latestBlock.baseFeePerGas);
            blockNumber = BigInt(latestBlock.number);

            if (!(baseFee >= PRIORITY_FEE_ESTIMATION_TRIGGER)) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return getFeeHistory(provider, hexlify(FEE_HISTORY_BLOCKS), hexlify(blockNumber), [FEE_HISTORY_PERCENTILE]);

          case 11:
            _context.t0 = _context.sent;
            _context.next = 15;
            break;

          case 14:
            _context.t0 = undefined;

          case 15:
            feeHistory = _context.t0;
            return _context.abrupt("return", calculateFees(baseFee, feeHistory));

          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](0);
            console.error(_context.t1);
            return _context.abrupt("return", FALLBACK_ESTIMATE);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 19]]);
  }));

  return function estimateFees(_x) {
    return _ref.apply(this, arguments);
  };
}();